import type {AdCategory} from '@frontend/modules/public/ads/AdsModuleTypes'
import {useAdsStore} from '@frontend/stores'
import {useEventCallback} from 'swayok-react-mdb-ui-kit/helpers/useEventCallback'
import {NavigationService} from 'swayok-react-mdb-ui-kit/services/NavigationService'

// Возвращает обработчик применения выбора локации в панели поиска.
export function useItemsSearchCategorySelectedHandler(): (newCategory: AdCategory | null) => void {
    const setCategory = useAdsStore(
        state => state.setSearchPanelCategory
    )
    const makeItemsListUrl = useAdsStore(
        state => state.makeItemsListUrl
    )
    // Нажатие кнопки "Найти" для ключевых слов.
    return useEventCallback((newCategory: AdCategory | null): void => {
        // При смене категории нужно сбросить все фильтры,
        // кроме тех, что задаются в этом компоненте.
        setCategory(newCategory)
        NavigationService.navigate(makeItemsListUrl({
            category: newCategory,
        }))
    })
}
